import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`
export const InnerContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    overflow: auto;
    margin-top: 1.5rem;
    padding: 0 1rem 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0 0 1rem 0;
    }
`

export const MenuWrapper = styled.div`
    border: ${props => props.theme.typography.border.width.xxxThin}
        ${props => props.theme.typography.border.style.solid} ${props => props.theme.colors.tfwBlackOpacity10};
    border-radius: ${props => props.theme.typography.border.radius.xLarge};
    min-width: 9.75rem;
    margin-right: ${props => props.theme.spacing.xSmall};
    padding: calc(${props => props.theme.spacing.xxxSmall} + ${props => props.theme.spacing.xSmall}) 0
        ${props => props.theme.spacing.medium};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-width: 10.5rem;
        margin-right: ${props => props.theme.spacing.medium};
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        min-width: 11.5rem;
        margin-right: ${props => props.theme.spacing.large};
        padding-bottom: ${props => props.theme.spacing.large};
    }
`

export const MenuContainer = styled.a`
    text-align: ${props => props.theme.style.textAlign.left};
    text-decoration: none;
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${props => props.theme.style.alignItems.baseline};
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.colors.tfwBlack87};
    cursor: pointer;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        text-align: ${props => props.theme.style.textAlign.left};
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.column};
        align-items: ${props => props.theme.style.alignItems.baseline};
    }
`

export const IconBox = styled.div`
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 9.375rem 9.375rem;
    margin-left: calc(${props => props.theme.spacing.xxxSmall} + ${props => props.theme.spacing.xSmall});
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-left: calc(${props => props.theme.spacing.small} + ${props => props.theme.spacing.xxxSmall});
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: calc(${props => props.theme.spacing.xSmall} + ${props => props.theme.spacing.xxxSmall});
        margin-bottom: 0;
    }
`

export const Image = styled.img`
    width: ${props => props.theme.layout.small};
    height: ${props => props.theme.layout.small};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: ${props => props.theme.layout.large};
        height: ${props => props.theme.layout.large};
    }
`
export const TitleSpan = styled.h3`
    font-family: ${props => props.theme.typography.font.family.lato};
    white-space: nowrap;
    display: ${props => props.theme.style.display.block};
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5rem;
    margin: 0 ${props => props.theme.spacing.medium};
    color: #282828;
    width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1rem;
        margin: 0 ${props => props.theme.spacing.large};
    }
`
export const SubtitleSpan = styled.span`
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    display: ${props => props.theme.style.display.block};
    font-weight: ${props => props.theme.typography.font.weight.normal};
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.0125rem;
    margin-left: ${props => props.theme.spacing.medium};
    color: #5f5f5f;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 0.875rem;
        line-height: 1rem;
        margin-left: ${props => props.theme.spacing.large};
    }
`
